import { render, staticRenderFns } from "./SampleTypeDropdown.vue?vue&type=template&id=946581b2"
import script from "./SampleTypeDropdown.vue?vue&type=script&lang=js"
export * from "./SampleTypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports